document.addEventListener('DOMContentLoaded', function(){
    const sidebar = document.querySelector('.wrapper-product-sticky');
    const wrapperSticky = document.querySelector('.wrapper-sticky-global');

    const intersectionObserver = new IntersectionObserver((object) => {
        object.forEach((element) => {
            if(element.isIntersecting){
                wrapperSticky.style.opacity = '0';
                setTimeout(() => {
                    wrapperSticky.style.zIndex = '-1';
                }, 400)
            } else {
                wrapperSticky.style.opacity = '1';
                wrapperSticky.style.zIndex = '2';
            }
        })
    }, {
        root: null,
        threshold: 0,
        rootMargin: '0px'
    })

    intersectionObserver.observe(sidebar);

    const initCountdown = () => {
        const wrapperCountdown = document.querySelectorAll('.wrapper-countdown');

        wrapperCountdown.forEach(countdown => {
            const targetDate = new Date(countdown.dataset.time).getTime();
            const daysElement = countdown.querySelector(".days");
            const hoursElement = countdown.querySelector(".hours");
            const minutesElement = countdown.querySelector(".minutes");
            const secondsElement = countdown.querySelector(".seconds");

            const updateCountdown = () => {
                const currentDate = new Date();
                const currentTimezoneOffset = currentDate.getTimezoneOffset();
                const localCurrentDate = new Date(currentDate.getTime() - currentTimezoneOffset * 60000);
                const localCurrentTime = localCurrentDate.getTime();
                const timeDifference = targetDate - localCurrentTime;
    
                if (timeDifference <= 0) {
                    daysElement.textContent = "00";
                    hoursElement.textContent = "00";
                    minutesElement.textContent = "00";
                    secondsElement.textContent = "00";
                } else {
                    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    
                    daysElement.textContent = String(days).padStart(2, "0");
                    hoursElement.textContent = String(hours).padStart(2, "0");
                    minutesElement.textContent = String(minutes).padStart(2, "0");
                    secondsElement.textContent = String(seconds).padStart(2, "0");
                }
            };
    
            updateCountdown();
            setInterval(updateCountdown, 1000);
        });
    }

    initCountdown();

});